import { defineMessages } from 'react-intl';

export default defineMessages({
  typeahead: {
    id: 'app.components.Elements.dropdown.typeahead',
    defaultMessage: 'Filter options…',
  },
  noRecords: {
    id: 'app.components.Elements.dropdown.noRecords',
    defaultMessage: 'No records found',
  },
});
